<template>
  <h2 class="title is-h2">
    <slot />
  </h2>
</template>

<script>
export default {
  name: 'RsH2'
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

h2 {
  color: var(--gray-900);
  font-size: $h2-headline;
  line-height: $lh-h2-headline;
  font-weight: $font-bold;

  @media (max-width: 768px) {
  }
}
</style>
